/* Peakspan-fleet WELCOME10 capture popup v1 — 2026-08-21 (B-67, owner-approved popup route)
   Self-contained: no deps, no external hosts. Shows once per 14 days, after 9s or exit-intent.
   Success path posts to Shopify's native contact form as customer -> accepts marketing ->
   the store's "Welcome new subscriber" automation sends the WELCOME10 email. */
(function () {
  'use strict';
  var KEY = 'ps_welcome_popup_v1';
  var now = Date.now();
  try {
    var seen = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (seen && (seen.done || now - seen.t < 14 * 864e5)) return;
  } catch (e) { return; }
  if (/\/(checkouts?|cart|account|challenge)\b/.test(location.pathname)) return;

  var BRAND = (window.Shopify && Shopify.shop) || location.hostname;
  var shown = false;

  function markSeen(done) {
    try { localStorage.setItem(KEY, JSON.stringify({ t: now, done: !!done })); } catch (e) {}
  }

  function build() {
    if (shown) return; shown = true;
    var wrap = document.createElement('div');
    wrap.id = 'ps-wpop';
    wrap.innerHTML =
      '<div class="ps-wpop-back" role="presentation"></div>' +
      '<div class="ps-wpop-card" role="dialog" aria-modal="true" aria-label="Welcome offer">' +
      '<button class="ps-wpop-x" aria-label="Close">&times;</button>' +
      (window.GP_PORTRAIT ? '<div class="ps-wpop-img" role="img" aria-label="Geroprotect Essentials II" style="background-image:url(' + window.GP_PORTRAIT + ')"></div>' : '') +
      '<div class="ps-wpop-body">' +
      '<p class="ps-wpop-kicker">Welcome offer</p>' +
      '<h2 class="ps-wpop-h">10% off your first order</h2>' +
      '<p class="ps-wpop-p">Join the list and we’ll email your personal WELCOME10 code right away.</p>' +
      '<form class="ps-wpop-f" method="post" action="/contact#contact_form" accept-charset="UTF-8">' +
      '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="\u2713">' +
      '<input type="hidden" name="contact[tags]" value="newsletter,popup-welcome15">' +
      '<input type="email" name="contact[email]" required autocomplete="email" placeholder="Your email" aria-label="Email">' +
      '<button type="submit">Get 10% off</button>' +
      '</form>' +
      '<p class="ps-wpop-fine">One use per customer. Unsubscribe anytime.</p>' +
      '<p class="ps-wpop-ok" hidden>Done — check your inbox for your code.</p>' +
      '</div>' +
      '</div>';
    if (window.GP_PORTRAIT) wrap.querySelector('.ps-wpop-card').classList.add('ps-wpop-card--img');
    var css = document.createElement('style');
    css.textContent =
      '#ps-wpop{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;font-family:inherit}' +
      '#ps-wpop .ps-wpop-back{position:absolute;inset:0;background:rgba(10,12,14,.55)}' +
      '#ps-wpop .ps-wpop-card{position:relative;background:#fff;color:#14171a;max-width:400px;width:calc(100% - 40px);padding:30px 28px 22px;border-radius:10px;box-shadow:0 24px 70px rgba(0,0,0,.35);text-align:center}' +
      '#ps-wpop .ps-wpop-x{position:absolute;top:8px;right:12px;background:none;border:0;font-size:26px;line-height:1;cursor:pointer;color:#888;padding:6px}' +
      '#ps-wpop .ps-wpop-kicker{font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#777;margin:0 0 6px}' +
      '#ps-wpop .ps-wpop-h{font-size:26px;line-height:1.15;margin:0 0 8px}' +
      '#ps-wpop .ps-wpop-p{font-size:15px;color:#444;margin:0 0 16px}' +
      '#ps-wpop .ps-wpop-f{display:flex;gap:8px;flex-wrap:wrap}' +
      '#ps-wpop .ps-wpop-f input{flex:1 1 150px;min-width:0;padding:12px 14px;border:1px solid #cfcfcf;border-radius:6px;font-size:15px}' +
      '#ps-wpop .ps-wpop-f button{flex:0 0 auto;padding:12px 18px;border:0;border-radius:6px;background:#14171a;color:#fff;font-size:15px;font-weight:600;cursor:pointer}' +
      '#ps-wpop .ps-wpop-fine{font-size:11.5px;color:#999;margin:12px 0 0}' +
      '#ps-wpop .ps-wpop-ok{font-size:15px;font-weight:600;color:#0E8A6D;margin:14px 0 4px}' +
      '#ps-wpop .ps-wpop-card--img{max-width:780px;display:grid;grid-template-columns:minmax(0,46%) minmax(0,1fr);padding:0;overflow:hidden;text-align:left;border-radius:14px}' +
      '#ps-wpop .ps-wpop-img{background-size:cover;background-position:center top;min-height:100%}' +
      '#ps-wpop .ps-wpop-card--img .ps-wpop-body{padding:38px 30px 26px}' +
      '#ps-wpop .ps-wpop-card--img .ps-wpop-x{color:#fff;text-shadow:0 1px 4px rgba(0,0,0,.5)}' +
      '@media (max-width:640px){#ps-wpop .ps-wpop-card--img{grid-template-columns:1fr;max-width:400px}#ps-wpop .ps-wpop-img{min-height:230px}#ps-wpop .ps-wpop-card--img .ps-wpop-body{padding:22px 22px 18px}}' +
      '@media (prefers-reduced-motion:no-preference){#ps-wpop .ps-wpop-card{animation:pswp .28s ease-out}}' +
      '@keyframes pswp{from{transform:translateY(14px);opacity:0}to{transform:none;opacity:1}}';
    document.head.appendChild(css);
    document.body.appendChild(wrap);

    function close() { markSeen(false); wrap.remove(); }
    wrap.querySelector('.ps-wpop-back').addEventListener('click', close);
    wrap.querySelector('.ps-wpop-x').addEventListener('click', close);
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });

    wrap.querySelector('.ps-wpop-f').addEventListener('submit', function () {
      markSeen(true); // native POST proceeds; Shopify handles success/challenge
    });
  }

  var t = setTimeout(build, 9000);
  document.addEventListener('mouseout', function exi(e) {
    if (!e.relatedTarget && e.clientY <= 0) { clearTimeout(t); document.removeEventListener('mouseout', exi); build(); }
  });
})();
